import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TmShipmentItem } from '@/tscapi/model/order';

import { en, fr } from './i18n';

interface ItemCardModifyProps {
    ShipmentItem: TmShipmentItem;
    containerCss?: string;
}

export const ItemCardModify = ({ ShipmentItem: item, containerCss }: ItemCardModifyProps) => {
    const { i18n, t } = useTranslation('shoppingbag');
    i18n.addResourceBundle('en', 'shoppingbag', en, true, true);
    i18n.addResourceBundle('fr', 'shoppingbag', fr, true, true);

    return (
        <>
            <div className={containerCss}>
                <div className="item__image">
                    <a href={item.ItemURL}>
                        <img
                            className="img-responsive"
                            width="175"
                            height="175"
                            alt=""
                            src={'https://item.tscimg.ca/TSC/' + item.ItemImageURL + '?impolicy=M'}
                        />
                    </a>
                </div>
                <div className="item__description">
                    <a href={item.ItemURL}>
                        <h3 className="item__name">{item.Description}</h3>
                    </a>
                    <div className="item__number">{item.ItemNoForDisplay}</div>
                    {(item.Size || item.Style) && (
                        <div className="item__style">
                            {item.Size && (
                                <span>
                                    {t('Size')}: {item.Size}
                                </span>
                            )}
                            {item.Size && item.Style && <span className="pipe-char">|</span>}
                            {item.Style && (
                                <span>
                                    {t('Style')}: {item.Style}
                                </span>
                            )}
                        </div>
                    )}
                    {item.SellerType === 'Marketplace' && (
                        <div className="seller__type">
                            <img
                                src="/App_Assets/public/marketplace-icon.svg"
                                alt="marketplace-icon"
                                className="marketplace__icon"
                            />
                            <div className="marketplace__text">{<>Marketplace Seller</>}</div>
                        </div>
                    )}
                    {/* quantity display if quantity selector disabled */}
                    <div className="item__style" style={{ marginBottom: '10px' }}>
                        Quantity: {item.ItemQuantity}
                    </div>
                </div>

                <div className="item__price item__price--modify">
                    <div>
                        <div style={{ textAlign: 'right' }}>
                            <span className="item__is-price">{item.UnitPrice}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
